import { SheduleEditorState } from 'types/state';
import { createSheduleEditorFormValues } from './createSheduleEditorFormValues';

export const createSheduleEditorState = (): SheduleEditorState => ({
  formValues: createSheduleEditorFormValues(),
  submited: false,
  submitDidSucceed: false
});
